import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";

/* -------------------------------------------------------------------------- */
/* Types                                                                      */
/* -------------------------------------------------------------------------- */

export type CardSerialInfo = {
  mainCardId: number | string;
  editionNumber?: number | string | null;
};

type CardSerialNumberProps = {
  cardInfo: CardSerialInfo;
  showLabel?: boolean;
  compact?: boolean;
};

/* -------------------------------------------------------------------------- */
/* Card Serial Number                                                         */
/* -------------------------------------------------------------------------- */

export const generateCardSerialNumber = (cardInfo: CardSerialInfo): string => {
  return `${cardInfo.mainCardId}${cardInfo.editionNumber ?? ""}`;
};

/* -------------------------------------------------------------------------- */
/* Component                                                                  */
/* -------------------------------------------------------------------------- */

export const CardSerialNumber: React.FC<CardSerialNumberProps> = ({
  cardInfo,
  showLabel = true,
  compact = false,
}) => {
  const serialNumber = useMemo(
    () => generateCardSerialNumber(cardInfo),
    [cardInfo.mainCardId, cardInfo.editionNumber]
  );

  return (
    <Box
      sx={{
        minWidth: 0,
      }}
    >
      {showLabel && (
        <Typography
          sx={{
            mb: 0.35,
            color: "rgba(255,255,255,.55)",
            fontSize: compact ? "0.62rem" : "0.7rem",
            lineHeight: 1.3,
          }}
        >
          Card Serial Number
        </Typography>
      )}

      <Typography
        sx={{
          color: "#ff8a00",
          fontFamily: '"Roboto Mono", "SFMono-Regular", Consolas, monospace',
          fontSize: compact
            ? {
                xs: "0.72rem",
                sm: "0.78rem",
              }
            : {
                xs: "0.82rem",
                sm: "0.9rem",
                md: "0.98rem",
              },
          fontWeight: 700,
          letterSpacing: "0.08em",
          lineHeight: 1.5,
          whiteSpace: "nowrap",
        }}
      >
        {serialNumber}
      </Typography>
    </Box>
  );
};

export default CardSerialNumber;
